/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type ErrorEnum = "ADMIN_UNAUTHORIZED" | "ALREADY_SUBSCRIBED" | "ANONYMOUS_USER" | "BAD_PROBLEM_CONTENT_ID" | "BAD_SCHOOL_ID" | "BAD_TASK_TEMPLATE_GROUP_ID" | "BAD_TASK_TEMPLATE_ID" | "BLANK_TASK_TEMPLATE_TITLE" | "CANNOT_ADD_EMAIL" | "CANNOT_INTERACT_WITH_WORKOUT" | "CANNOT_JOIN_CLASS" | "CHALLENGE_ALREADY_COMPLETED" | "CHALLENGE_NOT_ACTIVE" | "CHALLENGE_NOT_COMPLETABLE_FROM_CLIENT" | "CHALLENGE_NOT_COMPLETE" | "CHECK_IN_ALREADY_COMPLETED" | "CHECK_IN_CREATION_FAILURE" | "CHECK_IN_NOT_AVAILABLE" | "CLASS_ALREADY_ACTIVE" | "CLASS_ALREADY_ARCHIVED" | "CLASS_HAS_LEADERBOARD_DISABLED" | "CLASS_IN_DIFFERENT_SCHOOL" | "CLASS_UPDATE" | "CODE_NOT_PROVIDED" | "CONFIG_ONLY" | "COUNTRY_NOT_ALLOWED" | "DEMO_TEACHER_SPECIFIED_CODE" | "DIAGNOSTIC_CHECK_IN_EXISTS_FOR_STRAND" | "DUE_DATE_BEFORE_START_DATE" | "DUE_DATE_IN_THE_PAST" | "DUPLICATE_EMAIL" | "DUPLICATE_ITEM_TYPES" | "EMAIL_NOT_VERIFIED" | "EMPTY_AGREEMENT_TEXT" | "EMPTY_CLASS_DISPLAY_NAME" | "EMPTY_CLASS_TITLE" | "EMPTY_GROUP_TITLE" | "EMPTY_SANA_TOPICS" | "EMPTY_SCHOOL" | "EMPTY_SCHOOL_TITLE" | "FREEMIUM_TEACHER_ADDING_TOO_MANY_STUDENTS_TO_CLASS" | "FREEMIUM_TEACHER_CANT_ADD_MORE_STUDENT_TO_CLASS" | "FREEMIUM_TEACHER_CANT_BE_IN_MORE_THAN_ONE_CLASS" | "FREEMIUM_TEACHER_CANT_HAVE_MULTIPLE_TEACHERS_IN_CLASS" | "FREE_TRIAL_ALREADY_STARTED" | "GAME_ALREADY_ENDED" | "GAME_ALREADY_STARTED" | "GAME_NOT_FOUND" | "GENERIC" | "INSUFFICIENT_FUNDS" | "INVALID_BACKGROUND" | "INVALID_BULK_TASK_TEMPLATE_MAPPING" | "INVALID_CHALLENGE_ID" | "INVALID_CHECK_IN" | "INVALID_CHECK_IN_STATE" | "INVALID_CLASS" | "INVALID_CLASS_CODE" | "INVALID_CLASS_DISPLAY_NAME_LENGTH" | "INVALID_CLASS_TITLE_LENGTH" | "INVALID_COUNTRY_SUBDIVISION_CODE" | "INVALID_CREATE_STUDENT_FOR_LANTERN_ARGS" | "INVALID_CREATE_TEACHER_FOR_LANTERN_ARGS" | "INVALID_CURRICULUM" | "INVALID_DATA" | "INVALID_DISTRICT_ID" | "INVALID_EMAIL" | "INVALID_EMAIL_LENGTH" | "INVALID_FIRST_NAME_LENGTH" | "INVALID_GAME_DURATION" | "INVALID_GRADE" | "INVALID_GRADE_STRAND" | "INVALID_GROUP" | "INVALID_LAST_NAME_LENGTH" | "INVALID_NUMBER_OF_QUESTIONS" | "INVALID_ONBOARDING_FEATURE_ID_LENGTH" | "INVALID_OUTCOME" | "INVALID_PARENT_EMAIL" | "INVALID_PARENT_EMAIL_LENGTH" | "INVALID_PARENT_SUBSCRIBER" | "INVALID_PASSWORD" | "INVALID_POINTS" | "INVALID_POINT_SOURCE" | "INVALID_PROBLEM" | "INVALID_PROMOTED_FEATURE" | "INVALID_PUBLISHING_VERSION_ID" | "INVALID_QUESTION_DATA" | "INVALID_RECOGNITION" | "INVALID_SCHOOL" | "INVALID_SCHOOL_REFERENCE" | "INVALID_SCHOOL_TITLE_LENGTH" | "INVALID_SHOP_ITEM" | "INVALID_SKILL" | "INVALID_STRAND" | "INVALID_STUDENT" | "INVALID_SUBPROBLEM_TYPE" | "INVALID_SUBSTRAND" | "INVALID_SUBTOPIC_FOR_ADAPTIVE_SESSION" | "INVALID_SUBTOPIC_FOR_SYLLABUS" | "INVALID_SUBTOPIC_ID" | "INVALID_SYLLABUS" | "INVALID_SYLLABUS_FOCUS_FOR_SIGNUP" | "INVALID_TASK_ID" | "INVALID_TASK_TEMPLATE_ID" | "INVALID_TASK_TEMPLATE_ROW" | "INVALID_TEACHER" | "INVALID_TIMEZONE" | "INVALID_TOPIC" | "INVALID_UNITS" | "INVALID_USER_NOTIFICATION" | "INVALID_WORKOUT_ID" | "ITEMS_NOT_OWNED" | "ITEM_ALREADY_OWNED" | "ITEM_NOT_PURCHASABLE" | "LANTERN_COPY_OF_SAME_AS_QUESTION" | "LANTERN_INVALID_QUESTION_ID_FORMAT" | "LANTERN_PROFILE_ALREADY_EXISTS" | "LANTERN_QUESTIONS_THAT_ARE_PUBLISHED_CANNOT_BE_REMOVED" | "LANTERN_QUESTION_ALREADY_EXISTS_IN_SKILL" | "LANTERN_QUESTION_DOES_NOT_EXIST" | "LANTERN_QUESTION_NOT_IN_RESETABLE_STATE" | "LANTERN_SKILL_DOES_NOT_EXIST" | "LANTERN_TEACHER_EMAIL_ALREADY_VERIFIED" | "LANTERN_TEACHER_INVITE_CODE_EXPIRED" | "LANTERN_TEACHER_INVITE_CODE_INVALID" | "LOGIN_REQUIRED" | "MINIMUM_QUESTION_TARGET_OUT_OF_RANGE" | "NEGATIVE_EXTENSION_DAYS" | "NOT_ALLOWED_TO_MODIFY_USER" | "NOT_A_STUDENT" | "NOT_A_TEACHER" | "NOT_ELIGIBLE_FOR_POINTS" | "NOT_ELIGIBLE_FOR_REWARDS" | "NOT_ENOUGH_QUESTIONS_FOR_CHECKIN" | "NOT_SUPPORTED" | "NO_AREA_OF_STUDY" | "NO_ASSIGNEES_FOR_CHECKIN" | "NO_ASSIGNEES_FOR_TASK" | "NO_CHEATING" | "NO_CLASSES_FOR_STUDENT" | "NO_FEATURE" | "NO_FEATURES_BEING_PROMOTED" | "NO_FEATURE_NAME" | "NO_GRADE_STRANDS_CHECK_IN" | "NO_LANTERN_PROFILE" | "NO_LEADERBOARD_CLASS" | "NO_OPTIONAL_ARGUMENT_PROVIDED" | "NO_PROBLEM_CONTENT" | "NO_STUDENTS_OR_CLASSES" | "NO_SYLLABUSES_FOR_CLASS" | "NO_TEACHERS_FOR_CLASS" | "NO_TEMPORARY_PASSWORD" | "NO_VALUE" | "OLD_PASSWORD_CHECK" | "OPEN_PROMPT_LIMIT_REACHED" | "OPEN_PROMPT_UNAVAILABLE" | "PARENT_SUBSCRIBER_ALREADY_EXISTS" | "PDF_MISSING" | "PERMISSION" | "POINTS_ALREADY_CLAIMED" | "PRE_TOPIC_TEST_CHECK_IN_ALREADY_EXISTS_FOR_TASK" | "RATE_LIMITED" | "REATTEMPT_PROBLEM_EXPIRED_WORKOUT" | "REATTEMPT_PROBLEM_INCOMPLETE_PROBLEM" | "REATTEMPT_PROBLEM_NOT_CUSTOM_WORKOUT" | "REATTEMPT_PROBLEM_NO_WORKOUT" | "REATTEMPT_PROBLEM_RETRY_DISABLED" | "REWARD_ALREADY_CLAIMED" | "SAME_PASSWORD" | "SCHOOL_HAS_NO_SCHOOL_REFERENCE" | "SCHOOL_HAS_NO_WAYPOINTS_CURRICULUM" | "SCHOOL_INACTIVE" | "SCHOOL_REFERENCE_MISMATCH" | "SPARKLE_GLOBAL_RATE_LIMITED" | "SPARKLE_USER_RATE_LIMITED" | "STRAND_DIAGNOSTIC_CHECKIN_ALREADY_ASSIGNED" | "STUDENT_CANNOT_JOIN_FREEMIUM_CLASS_ALREADY_FULL" | "STUDENT_CREATION" | "STUDENT_HAS_STRAND_DIAGNOSTIC_CHECK_IN" | "STUDENT_ID_NOT_PROVIDED" | "STUDENT_IN_DIAGNOSTIC_PHASE" | "STUDENT_IN_STRAND_GROWTH_PHASE" | "STUDENT_IN_VERIFIED_SCHOOL" | "STUDENT_NOT_IN_CLASS" | "STUDENT_NOT_IN_GROUP" | "STUDENT_ONBOARDING_CHECKLIST_NOT_FOUND" | "STUDENT_UPDATE" | "SUBMIT_ANSWER_FAILURE" | "SUBTOPIC_MISSING_ENGAGE_ACTIVITY" | "SYLLABUS_ALREADY_PRESENT" | "SYLLABUS_NOT_PRESENT" | "TARGET_MASTERY_OUT_OF_RANGE" | "TASK_TEMPLATE_GROUP_BLANK_TITLE" | "TASK_TEMPLATE_GROUP_PERMISSION" | "TASK_TEMPLATE_GROUP_UNSHAREABLE" | "TASK_TEMPLATE_GROUP_WRONG_SCHOOL" | "TASK_TEMPLATE_IN_MULTIPLE_GROUPS_NOT_ALLOWED" | "TASK_TEMPLATE_NOT_OWNED" | "TASK_TEMPLATE_NOT_USABLE_BY_SCHOOL" | "TASK_TEMPLATE_TREE_MAX_DEPTH_EXCEEDED" | "TEACHERS_CANNOT_JOIN_CLASSES" | "TEACHER_ALREADY_IN_CLASS" | "TEACHER_ALREADY_IN_SCHOOL" | "TEACHER_CANNOT_JOIN_UNVERIFIED_SCHOOL" | "TEACHER_EMAIL_ALREADY_VERIFIED" | "TEACHER_FROM_DIFFERENT_SCHOOL" | "TEACHER_PREVIOUSLY_INVITED" | "TOO_MANY_GUARDIANS" | "UNAUTHORIZED_TASK_ASSIGNEES" | "USER_ONBOARDING_CHECKLIST_NOT_FOUND" | "USE_SHOP_FEATURE_INSTEAD" | "VALUE" | "WAYPOINTS_CURRICULUM_MISMATCH" | "WRONG_SCHOOL" | "classCode" | "country" | "email" | "firstName" | "lastName" | "parentEmail" | "password" | "syllabusFocusId" | "timezone";
export type FeedbackScore = "NEGATIVE" | "POSITIVE";
export type FeedbackSubtypeEnum = "ANSWER_KEY_OTHER" | "ANSWER_KEY_SOMETHING_NOT_DISPLAYING_CORRECTLY" | "ANSWER_KEY_THERE_IS_AN_ERROR" | "ANSWER_KEY_WANT_TO_MAKE_SUGGESTION" | "ANSWER_SHOULD_BE_CORRECT" | "CHECK_IN_DIFFICULT" | "CHECK_IN_EASY" | "CLASS_MASTERY_SYLLABUS_MISSING_FEATURE" | "CLASS_MASTERY_SYLLABUS_PERFORMANCE_ISSUES" | "CLASS_MASTERY_SYLLABUS_PREFER_NEW_REPORT" | "CONFUSING_HINT" | "CONFUSING_QUESTION" | "DASHBOARD_MISSING_FEATURE" | "DASHBOARD_PERFORMANCE_ISSUES" | "DASHBOARD_PREFER_OLD_DESIGN" | "GRADING_TAKES_TOO_LONG" | "HANDWRITING_PANEL_ISSUES" | "HAVING_TROUBLES_ANSWERING" | "HINT_WITH_MISTAKES" | "LESSON_CONFUSING" | "LESSON_NOT_HELPFUL" | "LESSON_WITH_MISTAKES" | "NEGATIVE" | "NOT_HELPFUL_HINT" | "NTE_MISSING_FEATURE" | "NTE_NEED_MORE_TIME_TO_ADJUST" | "NTE_PERFORMANCE_ISSUES" | "NTE_POSITIVE" | "NWE_MISSING_FEATURE" | "NWE_PERFORMANCE_ISSUES" | "NWE_PREFER_OLD_DESIGN" | "OTHER" | "POSITIVE" | "PRACTICE_TOO_DIFFICULT" | "PRACTICE_TOO_EASY" | "QUESTION_HAS_MISTAKES" | "QUESTION_TOO_LONG" | "SKILLS_MAP_0" | "SKILLS_MAP_1" | "SKILLS_MAP_2" | "SKILLS_MAP_3" | "SKILLS_MAP_4" | "SOMETHING_IS_BROKEN" | "STUDENT_REPORT_MISSING_FEATURE" | "STUDENT_REPORT_PERFORMANCE_ISSUES" | "STUDENT_REPORT_PREFER_NEW_REPORT" | "STUDENT_SUNFLOWER_DASHBOARD_0" | "STUDENT_SUNFLOWER_DASHBOARD_1" | "STUDENT_SUNFLOWER_DASHBOARD_2" | "STUDENT_SUNFLOWER_DASHBOARD_3" | "STUDENT_SUNFLOWER_DASHBOARD_4" | "STUDENT_SUNFLOWER_MISSING_FEATURE" | "STUDENT_SUNFLOWER_NEED_MORE_TIME" | "STUDENT_SUNFLOWER_TASKS_0" | "STUDENT_SUNFLOWER_TASKS_1" | "STUDENT_SUNFLOWER_TASKS_2" | "STUDENT_SUNFLOWER_TASKS_3" | "STUDENT_SUNFLOWER_TASKS_4" | "SUPPLIED_ANSWER_IS_INCORRECT" | "TASK_TOKEN_WORKBOOK_0" | "TASK_TOKEN_WORKBOOK_1" | "TASK_TOKEN_WORKBOOK_2" | "TASK_TOKEN_WORKBOOK_3" | "TASK_TOKEN_WORKBOOK_4" | "TEMPLATES_NAV_V2_MISSING_FEATURE" | "TEMPLATES_NAV_V2_PERFORMANCE_ISSUES" | "TEMPLATES_NAV_V2_PREFER_OLD_DESIGN" | "TEMPLATE_MISSING_FEATURE" | "TEMPLATE_PERFORMANCE_ISSUES" | "TEMPLATE_PREFER_SHARED_EXERCISES" | "TEXTBOOK_MISSING_FEATURE" | "TEXTBOOK_PERFORMANCE_ISSUES" | "TEXTBOOK_PREFER_OLD_DESIGN" | "VIDEO_WRONG_FOR_QUESTION" | "WORKBOOK_FRUSTRATING" | "WORKBOOK_HELP_TIPS_ALREADY_KNEW" | "WORKBOOK_HELP_TIPS_FOUND_THIS_HELPFUL" | "WORKBOOK_HELP_TIPS_NOT_RELEVANT" | "WORKSHEET_OTHER" | "WORKSHEET_SOMETHING_NOT_DISPLAYING_CORRECTLY" | "WORKSHEET_THERE_IS_AN_ERROR" | "WORKSHEET_WANT_TO_MAKE_SUGGESTION";
export type FeedbackTypeEnum = "AI_HINTS" | "ANSWER_KEY_SUBMIT_FEEDBACK" | "ASSIGNED_PAGE" | "CALCULATOR" | "CHECKIN_COMPLETE" | "CHECKIN_EXIT" | "CHECKIN_QUESTION" | "CLASS_MASTERY_SYLLABUS_SUBMIT_FEEDBACK" | "DASHBOARD" | "GENERAL" | "GLOBAL_SEARCH" | "HINT" | "HINTS" | "LEGACY_SKILL_REPORT" | "LESSON" | "LESSONS" | "NEW_FEATURE_NOTIFICATION" | "NTE_OPTOUT" | "NTE_SUBMIT_FEEDBACK" | "NWE_OPTIN" | "NWE_OPTOUT" | "OVERALL" | "PRACTICE_QUESTIONS" | "SKILLS_MAP" | "SKILLS_MAP_SUBMIT_FEEDBACK" | "SKILLS_REPORT_WITH_PROBLEM_DATA" | "STEPS" | "STUDENT_DASHBOARD_SUBMIT_ISSUE" | "STUDENT_REPORT_SUBMIT_FEEDBACK" | "STUDENT_SUNFLOWER_DASHBOARD_SUBMIT_FEEDBACK" | "STUDENT_SUNFLOWER_OPTOUT" | "STUDENT_SUNFLOWER_TASKS_SUBMIT_FEEDBACK" | "SUBTOPIC_RECOMMENDATION_WORKOUT_COMPLETE" | "SUBTOPIC_RECOMMENDATION_WORKOUT_EXIT" | "TASK_TEMPLATES_SUBMIT_ISSUE" | "TASK_TOKEN_WORKBOOK_SUBMIT_FEEDBACK" | "TEMPLATES_NAV_V2_SWITCHED_BACK_TO_OLD" | "TEXTBOOK_SUBMIT_ISSUE" | "WORKBOOK_COMPLETE" | "WORKBOOK_EXIT" | "WORKBOOK_HELP_TIPS" | "WORKBOOK_NOTATION_GUIDE" | "WORKBOOK_PT" | "WORKED_EXAMPLE" | "WORKED_SOLUTION_STEPS" | "WORKED_SOLUTION_VIDEO" | "WORKSHEET" | "WORKSHEET_SUBMIT_FEEDBACK";
export type useSubmitFeedbackMutationVariables = {
    feedbackType: FeedbackTypeEnum;
    feedbackSubtype: FeedbackSubtypeEnum;
    score?: FeedbackScore | null | undefined;
    supportingText?: string | null | undefined;
    rawDebugInfo?: string | null | undefined;
    workoutId?: string | null | undefined;
    workEventId?: string | null | undefined;
    problemId?: string | null | undefined;
    subproblemId?: string | null | undefined;
    checkinId?: string | null | undefined;
    checkinQuestionId?: string | null | undefined;
    subtopicId?: string | null | undefined;
};
export type useSubmitFeedbackMutationResponse = {
    readonly submitFeedback: {
        readonly errors: ReadonlyArray<{
            readonly key: ErrorEnum;
            readonly message: string;
        }>;
    };
};
export type useSubmitFeedbackMutation = {
    readonly response: useSubmitFeedbackMutationResponse;
    readonly variables: useSubmitFeedbackMutationVariables;
};



/*
mutation useSubmitFeedbackMutation(
  $feedbackType: FeedbackTypeEnum!
  $feedbackSubtype: FeedbackSubtypeEnum!
  $score: FeedbackScore
  $supportingText: String
  $rawDebugInfo: String
  $workoutId: ID
  $workEventId: ID
  $problemId: ID
  $subproblemId: ID
  $checkinId: ID
  $checkinQuestionId: ID
  $subtopicId: ID
) {
  submitFeedback(feedback: {feedbackType: $feedbackType, feedbackSubtype: $feedbackSubtype, score: $score, supportingText: $supportingText, rawDebugInfo: $rawDebugInfo, workoutId: $workoutId, workEventId: $workEventId, problemId: $problemId, subproblemId: $subproblemId, checkinId: $checkinId, checkinQuestionId: $checkinQuestionId, subtopicId: $subtopicId}) {
    errors {
      key
      message
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "checkinId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "checkinQuestionId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "feedbackSubtype"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "feedbackType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "problemId"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "rawDebugInfo"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "score"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "subproblemId"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "subtopicId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "supportingText"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workEventId"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "workoutId"
},
v12 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "checkinId",
            "variableName": "checkinId"
          },
          {
            "kind": "Variable",
            "name": "checkinQuestionId",
            "variableName": "checkinQuestionId"
          },
          {
            "kind": "Variable",
            "name": "feedbackSubtype",
            "variableName": "feedbackSubtype"
          },
          {
            "kind": "Variable",
            "name": "feedbackType",
            "variableName": "feedbackType"
          },
          {
            "kind": "Variable",
            "name": "problemId",
            "variableName": "problemId"
          },
          {
            "kind": "Variable",
            "name": "rawDebugInfo",
            "variableName": "rawDebugInfo"
          },
          {
            "kind": "Variable",
            "name": "score",
            "variableName": "score"
          },
          {
            "kind": "Variable",
            "name": "subproblemId",
            "variableName": "subproblemId"
          },
          {
            "kind": "Variable",
            "name": "subtopicId",
            "variableName": "subtopicId"
          },
          {
            "kind": "Variable",
            "name": "supportingText",
            "variableName": "supportingText"
          },
          {
            "kind": "Variable",
            "name": "workEventId",
            "variableName": "workEventId"
          },
          {
            "kind": "Variable",
            "name": "workoutId",
            "variableName": "workoutId"
          }
        ],
        "kind": "ObjectValue",
        "name": "feedback"
      }
    ],
    "concreteType": "SubmitFeedbackResult",
    "kind": "LinkedField",
    "name": "submitFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "useSubmitFeedbackMutation",
    "selections": (v12/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v5/*: any*/),
      (v11/*: any*/),
      (v10/*: any*/),
      (v4/*: any*/),
      (v7/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/)
    ],
    "kind": "Operation",
    "name": "useSubmitFeedbackMutation",
    "selections": (v12/*: any*/)
  },
  "params": {
    "cacheID": "6d60ce6ceebe1569a623e396c6c09c4d",
    "id": null,
    "metadata": {},
    "name": "useSubmitFeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation useSubmitFeedbackMutation(\n  $feedbackType: FeedbackTypeEnum!\n  $feedbackSubtype: FeedbackSubtypeEnum!\n  $score: FeedbackScore\n  $supportingText: String\n  $rawDebugInfo: String\n  $workoutId: ID\n  $workEventId: ID\n  $problemId: ID\n  $subproblemId: ID\n  $checkinId: ID\n  $checkinQuestionId: ID\n  $subtopicId: ID\n) {\n  submitFeedback(feedback: {feedbackType: $feedbackType, feedbackSubtype: $feedbackSubtype, score: $score, supportingText: $supportingText, rawDebugInfo: $rawDebugInfo, workoutId: $workoutId, workEventId: $workEventId, problemId: $problemId, subproblemId: $subproblemId, checkinId: $checkinId, checkinQuestionId: $checkinQuestionId, subtopicId: $subtopicId}) {\n    errors {\n      key\n      message\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = '76a16e059afb3635dbaa3cdda3eb7d0c';
export default node;
